import { PaginatedData } from "src/library/utils";
import useAxios, { IApiResponse } from "src/core/shared/hooks/useAxios";

import {
  IOrder,
  IOrderNote
} from "./orders.api";

type OrderNoteApi = "ADD_ORDER_NOTE" | "DELETE_ORDER_NOTE";

export type DeleteOrderNoteParams = { orderId: number; orderNoteId: number };
export type AddOrderNoteParams = { note: IOrderNote; orderId: number };

export type OrdersResponse = {
  orders: PaginatedData<IOrder>;
  allOrdersWithErrors: number;
};
export const orderNotesApi = <R, P = any>(name: OrderNoteApi): [IApiResponse<R, any>, <C = P>(P: C) => void] => {
  switch (name) {
    case "ADD_ORDER_NOTE":
      return useAxios<R>((params: AddOrderNoteParams) => {
        return {
          url: `${process.env.REACT_APP_API_URL}/core/orders/${params.orderId}/notes`,
          method: "POST",
          data: params.note
        };
      }, name);

    case "DELETE_ORDER_NOTE":
      return useAxios<R>(
        ({ orderId, orderNoteId }: DeleteOrderNoteParams) => ({
          url: `${process.env.REACT_APP_API_URL}/core/orders/${orderId}/notes/${orderNoteId}`,
          method: "DELETE"
        }),
        name
      );

    default:
      throw new Error("orderNotesApi requires a name parameter");
  }
};
